const theme = {
  radius: '3px',
  container: {
    width: '1024px',
  },
  brand: {
    primary: '#ffe600',
    secondary: '#3483fa',
    dark1: '#333333',
    dark2: '#666666',
    dark3: '#999999',
    light: '#eeeeee',
    white: '#ffffff',
  },
  h1: {
    size: '46px',
    color: 'black',
    weight: 'normal',
  },
  h2: {
    size: '28px',
    color: 'black',
    weight: 'normal',
  },
  h3: {
    size: '24px',
    color: 'black',
    weight: 'bold',
  },
  paragraph: {
    size: '18px',
    color: 'black',
    weight: 'normal',
  },
  small: {
    size: '16px',
    color: 'black',
    weight: '200',
  },
  xsmall: {
    size: '14px',
    color: 'black',
    weight: '200',
  },
  button: {
    size: '16px',
    radius: '4px',
    padding: {
      horizontal: '12px',
      vertical: '32px',
    },
    primary: {
      color: '#ffffff',
      background: '#3483fa',
    },
  },
  spacing: {
    small: '12px',
    medium: '16px',
    large: '32px',
  },
  nav: {
    height: '54px',
  },
  input: {
    size: '18px',
    height: '39px',
    radius: '4px',
    border: 'none',
    weight: '200',
  },
};

export {theme};
